export function initRoleplayDetailsCollapseActions($scope = $(document)) {
    const STORAGE_PREFIX = 'growtype_chat_roleplay_details_hidden:';
    const $targetScope = $scope && $scope.length ? $scope : $(document);

    function getStorageKey($wrapper) {
        const $chatForm = $wrapper.closest('.g-chatform');
        const sessionToken = ($chatForm.attr('data-session-token') || '').trim();
        const roleplayKey = ($wrapper.attr('data-roleplay-key') || '').trim();

        return [
            STORAGE_PREFIX,
            sessionToken || 'no-session',
            roleplayKey || 'no-roleplay'
        ].join('');
    }

    function readHiddenState($wrapper) {
        const storageKey = getStorageKey($wrapper);

        try {
            return window.sessionStorage?.getItem(storageKey) === '1';
        } catch (error) {
            return $wrapper.hasClass('is-hidden');
        }
    }

    function writeHiddenState($wrapper, isHidden) {
        const storageKey = getStorageKey($wrapper);

        try {
            window.sessionStorage?.setItem(storageKey, isHidden ? '1' : '0');
        } catch (error) {
            // Ignore storage failures and keep the UI state local to the DOM.
        }
    }

    function syncWrapper($wrapper) {
        if (!$wrapper?.length) {
            return;
        }

        const isHidden = readHiddenState($wrapper);
        $wrapper
            .toggleClass('is-hidden', isHidden)
            .attr('data-roleplay-details-hidden', isHidden ? '1' : '0');
    }

    function syncAll(scope = $targetScope) {
        (scope || $(document)).find('.roleplay-details-wrapper').each(function () {
            syncWrapper($(this));
        });
    }

    $(document)
        .off('click.growtypeChatRoleplayDetailsCollapse', '.roleplay-details-close')
        .on('click.growtypeChatRoleplayDetailsCollapse', '.roleplay-details-close', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const $wrapper = $(this).closest('.roleplay-details-wrapper');

            if (!$wrapper.length) {
                return;
            }

            const isHidden = !$wrapper.hasClass('is-hidden');
            $wrapper
                .toggleClass('is-hidden', isHidden)
                .attr('data-roleplay-details-hidden', isHidden ? '1' : '0');
            writeHiddenState($wrapper, isHidden);
        })
        .off('growtypeChatContentRendered.growtypeChatRoleplayDetailsCollapse')
        .on('growtypeChatContentRendered.growtypeChatRoleplayDetailsCollapse', function (event) {
            syncAll($(event?.detail?.contentWrapper || document));
        })
        .off('growtypeChatMessageReturnFinished.growtypeChatRoleplayDetailsCollapse')
        .on('growtypeChatMessageReturnFinished.growtypeChatRoleplayDetailsCollapse', function (event) {
            syncAll($(event?.detail?.userMessageTemplate || document));
        });

    syncAll($targetScope);
}
